/**
 * Slick Slider with breakpoints init
 * @module gwp‰esponsiveSlider
 */

import $ from 'jquery';
import './slick-carousel';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
export const PLUGIN_NAME = 'gwpResponsiveSlider';
export const INIT_HANDLER = 'init';
export const BP_HANDLER = 'breakpoint';
export const DEFAULTS = {};

/**
 * handle break points based num of slides
 */
const gwpBreakpoints = (breakpoint, totalSlides, slidesToShow, $slides, el) => {
	const $el = $(el);
	if(breakpoint === 1027) {
		if(totalSlides > slidesToShow) {
			$el.removeClass('gwp-confirm__grid--unslick');
			$slides.removeClass('gwp-confirm__grid-item--slide');
			$slides.addClass('gwp-confirm__grid-item--slide-init');
		} else {
			$el.addClass('gwp-confirm__grid--unslick');
			$slides.addClass('gwp-confirm__grid-item--slide');
			$slides.removeClass('gwp-confirm__grid-item--slide-init')
		}
	} else {
		if(totalSlides > slidesToShow) {
			$el.removeClass('gwp-confirm__grid--unslick');
			$slides.addClass('gwp-confirm__grid-item--slide-init');
			$slides.removeClass('gwp-confirm__grid-item--slide');
		} else {
			$el.addClass('gwp-confirm__grid--unslick');
			$slides.addClass('gwp-confirm__grid-item--slide');
			$slides.removeClass('gwp-confirm__grid-item--slide-init')
		}
	}
}

const setEventListeners = (initTrack) => {
	$(initTrack).on(INIT_HANDLER, (evt, slick) => {
		const breakpoint = slick.activeBreakpoint;
		const totalSlides = slick.$slides.length;
		const slidesToShow = slick.options.slidesToShow;
		const $slides = slick.$slideTrack.find('.gwp-confirm__grid-item');
		const el = $(initTrack);
		gwpBreakpoints(breakpoint, totalSlides, slidesToShow, $slides, el);
	})
	$(initTrack).on(BP_HANDLER, (evt, slick, breakpoint) => {
		const totalSlides = slick.$slides.length;
		const slidesToShow = slick.options.slidesToShow;
		const $slides = slick.$slideTrack.find('.gwp-confirm__grid-item');
		const el = $(initTrack);
		gwpBreakpoints(breakpoint, totalSlides, slidesToShow, $slides, el);
	})
}

/**
 * Initializes Breakpoint logic.
 * @param {HTMLElement} $initTrack - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function gwpResponsiveSlider(el, options) {
	const $el = $(el);
	setEventListeners($el);
}
registerJQueryPlugin(PLUGIN_NAME, gwpResponsiveSlider);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/gwp-responsive-slider.js